export default __webpack_public_path__ + "static/media/assetCorrection.debf7a33.svg";